module.exports = __webpack_public_path__ + "static/img/template1.6f3a7d67.png";